import { Pipe, PipeTransform } from '@angular/core'
import { TicketNote } from '../_models'

/**
 * Sortiert Logbucheinträge so, dass fixierte (pinned) Einträge oben stehen.
 * Die Reihenfolge innerhalb der beiden Gruppen bleibt erhalten (stabiles Sortieren).
 */
@Pipe({
  name: 'pinnedFirst',
})
export class PinnedFirstPipe implements PipeTransform {
  transform(notes: TicketNote[] | null | undefined): TicketNote[] {
    if (!notes) {
      return notes
    }

    return [...notes].sort((a, b) => Number(b.pinned === true) - Number(a.pinned === true))
  }
}
